import React from 'react'
import ModalInlineNotice from '../components/ModalInlineNotice'
import type { GlossaryReadinessViewModel } from './translationModalViewModels'

export type TranslationGlossaryReadinessTone = 'neutral' | 'info' | 'warning' | 'success'

interface TranslationGlossaryReadinessNoticeProps {
  viewModel?: GlossaryReadinessViewModel
  message?: React.ReactNode
  action?: React.ReactNode
  tone?: TranslationGlossaryReadinessTone
  title?: React.ReactNode
}

const TranslationGlossaryReadinessNotice: React.FC<TranslationGlossaryReadinessNoticeProps> = ({
  viewModel,
  message,
  action,
  title,
  tone = 'success',
}) => {
  const resolvedTitle = title || viewModel?.title || 'Glossary readiness'
  const resolvedMessage = viewModel?.message || message
  const resolvedTone = viewModel?.tone || tone
  const stateClass = viewModel?.state ? ` translation-glossary-readiness--${viewModel.state}` : ''
  const inlineClass = viewModel?.state === 'no_target' ? ' translation-glossary-readiness--inline' : ''

  return (
    <div className={`translation-glossary-readiness${stateClass}${inlineClass}`}>
      <div className="translation-modal-subheading">{resolvedTitle}</div>
      <ModalInlineNotice message={resolvedMessage} action={action} tone={resolvedTone} />
    </div>
  )
}

export default TranslationGlossaryReadinessNotice
